// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

// 椤甸潰缁勪欢瀵煎叆
const Login = () => import('../views/Login.vue')
const Layout = () => import('../views/Layout.vue')
const Dashboard = () => import('../views/Dashboard.vue')
const Forbidden = () => import('../views/403.vue')

// 鐢ㄦ埛浣撶郴
const UserList = () => import('../views/user/List.vue')
const UserDetail = () => import('../views/user/Detail.vue')
const UsersIndex = () => import('../views/users/index.vue')
const UsersDetail = () => import('../views/users/detail.vue')
const ChannelList = () => import('../views/channel/List.vue')
const PromotionAudit = () => import('../views/promotion/Audit.vue')
const PrivateDomainIndex = () => import('../views/private-domain/Index.vue')

// 鍟嗗搧浜ゆ槗
const OrderList = () => import('../views/order/List.vue')
const GoodsMallList = () => import('../views/goods-mall/List.vue')

// 璐㈠姟涓績
const FinanceSplit = () => import('../views/finance/Split.vue')
const FinancePoints = () => import('../views/finance/Points.vue')
const FinanceModel = () => import('../views/finance/Model.vue')

// 璁惧鍋ュ悍
const DeviceList = () => import('../views/device/List.vue')
const DeviceOwnershipApplications = () => import('../views/device/OwnershipApplications.vue')
const SkinReportList = () => import('../views/skin-report/List.vue')

// 鍐呭绠＄悊
const MaterialList = () => import('../views/materials/ContentCenter.vue')
const BannerList = () => import('../views/banner/List.vue')
const KnowledgeList = () => import('../views/knowledge/List.vue')

// 绯荤粺璁剧疆
const SystemConfig = () => import('../views/system/Config.vue')
const ParamConfig = () => import('../views/system/ParamConfig.vue')
const DictManagement = () => import('../views/system/DictManagement.vue')
const StaffAccounts = () => import('../views/staff/Accounts.vue')
const StaffManagement = () => import('../views/staff/Management.vue')
const StaffPermissions = () => import('../views/staff/Permissions.vue')
const StaffTemplates = () => import('../views/staff/Templates.vue')

// 鍏朵粬
const MessageList = () => import('../views/messages/index.vue')
const Stats = () => import('../views/Stats.vue')
const GoodsList = () => import('../views/goods/List.vue')

// 鏂板妯″潡
const OrganizationsList = () => import('../views/organizations/List.vue')
const StoresList = () => import('../views/stores/List.vue')
const CouponsList = () => import('../views/coupons/List.vue')
const PropagationIndex = () => import('../views/propagation/Index.vue')
const MedalsList = () => import('../views/medals/List.vue')
const ReviewsList = () => import('../views/reviews/List.vue')
const StockList = () => import('../views/stock/List.vue')
const StockLogs = () => import('../views/stock/Logs.vue')
const StockWarnings = () => import('../views/stock/Warnings.vue')
const VerificationList = () => import('../views/verification/List.vue')
const TalentList = () => import('../views/talent/List.vue')

/**
 * 璺敱閰嶇疆
 * meta.requiredRoles: 鍏佽璁块棶鐨勮鑹叉暟缁?
 * - [2]: 浠呭悎浣滃晢绠＄悊鍛?
 * - [3]: 浠呭憳宸?
 * - [4]: 浠呭钩鍙拌秴绠?
 * - [2, 4]: 鍚堜綔鍟嗙鐞嗗憳鍜屽钩鍙拌秴绠￠兘鍙闂?
 */
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/403',
    name: 'Forbidden',
    component: Forbidden,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      // 杩愯惀鎬昏
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { 
          title: '鏁版嵁澶у睆',
          requiredRoles: [2, 4] 
        }
      },

      // 鐢ㄦ埛浣撶郴
      {
        path: 'users',
        name: 'UserList',
        component: UsersIndex,
        meta: { 
          title: '鐢ㄦ埛绠＄悊',
          requiredRoles: [2, 4] 
        }
      },
      {
        path: 'users/:id',
        name: 'UserDetail',
        component: UsersDetail,
        meta: { 
          title: '鐢ㄦ埛璇︽儏',
          requiredRoles: [2, 4] 
        }
      },
      {
        path: 'private-domains',
        name: 'PrivateDomainIndex',
        component: PrivateDomainIndex,
        meta: {
          title: '私域管理',
          requiredRoles: [4]
        }
      },
      // 鏃х増鐢ㄦ埛绠＄悊锛堜繚鐣欑敤浜庤韩浠藉崌闄嶇骇鍔熻兘锛?
      {
        path: 'user/list',
        name: 'UserListOld',
        component: UserList,
        meta: { 
          title: '鐢ㄦ埛鍒楄〃锛堟棫鐗堬級',
          requiredRoles: [4] 
        }
      },
      {
        path: 'user/:id',
        name: 'UserDetailOld',
        component: UserDetail,
        meta: { 
          title: '鐢ㄦ埛璇︽儏锛堟棫鐗堬級',
          requiredRoles: [4] 
        }
      },
      {
        path: 'channels',
        name: 'ChannelList',
        component: ChannelList,
        meta: {
          title: '渠道管理',
          requiredRoles: [4]
        }
      },
      // 鍟嗗搧浜ゆ槗
      {
        path: 'packages',
        redirect: '/goods-mall'
      },
      {
        path: 'goods-mall',
        name: 'GoodsMallList',
        component: GoodsMallList,
        meta: { 
          title: '商品管理',
          requiredRoles: [4] 
        }
      },
      {
        path: 'service-products',
        redirect: '/goods-mall'
      },
      {
        path: 'points-mall',
        redirect: '/goods-mall'
      },
      {
        path: 'orders',
        name: 'OrderList',
        component: OrderList,
        meta: { 
          title: '璁㈠崟绠＄悊',
          requiredRoles: [2, 4] 
        }
      },

      // 璐㈠姟涓績
      {
        path: 'finance/split',
        name: 'FinanceSplit',
        component: FinanceSplit,
        meta: { 
          title: '鍒嗚处瀹¤',
          requiredRoles: [2, 4] 
        }
      },
      {
        path: 'finance/model',
        name: 'FinanceModel',
        component: FinanceModel,
        meta: {
          title: '鍒嗚处妯″瀷',
          requiredRoles: [4]
        }
      },
      {
        path: 'finance/points',
        name: 'FinancePoints',
        component: FinancePoints,
        meta: { 
          title: '绉垎绠＄悊',
          requiredRoles: [4] 
        }
      },

      // 璁惧鍋ュ悍
      {
        path: 'devices',
        name: 'DeviceList',
        component: DeviceList,
        meta: { 
          title: '璁惧绠＄悊',
          requiredRoles: [3, 4] 
        }
      },
      {
        path: 'device-ownership-applications',
        name: 'DeviceOwnershipApplications',
        component: DeviceOwnershipApplications,
        meta: {
          title: '设备买断申请',
          requiredRoles: [4]
        }
      },
      {
        path: 'skin-reports',
        name: 'SkinReportList',
        component: SkinReportList,
        meta: { 
          title: '测肤报告中心',
          requiredRoles: [4]
        }
      },

      // 鍐呭绠＄悊
      {
        path: 'materials',
        name: 'MaterialList',
        component: MaterialList,
        meta: {
          title: '绱犳潗绠＄悊',
          requiredRoles: [2, 3, 4]
        }
      },
      {
        path: 'banners',
        name: 'BannerList',
        component: BannerList,
        meta: {
          title: '轮播图管理',
          requiredRoles: [4]
        }
      },
      {
        path: 'promotions/audit',
        name: 'PromotionAudit',
        component: PromotionAudit,
        meta: {
          title: '娲诲姩瀹℃牳',
          requiredRoles: [3, 4]
        }
      },
      {
        path: 'knowledge',
        name: 'KnowledgeList',
        component: KnowledgeList,
        meta: {
          title: '知识库',
          requiredRoles: [4]
        }
      },
      // 娑堟伅鎺ㄩ€?
      {
        path: 'messages',
        name: 'MessageList',
        component: MessageList,
        meta: { 
          title: '消息推送日志',
          requiredRoles: [2, 4] 
        }
      },

      // 绯荤粺璁剧疆
      {
        path: 'staff/management',
        name: 'StaffManagement',
        component: StaffManagement,
        meta: { 
          title: '鍛樺伐绠＄悊',
          requiredRoles: [2, 4] 
        }
      },
      {
        path: 'staff/accounts',
        name: 'StaffAccounts',
        component: StaffAccounts,
        meta: { 
          title: '鍛樺伐璐﹀彿绠＄悊',
          requiredRoles: [2, 4] 
        }
      },
      {
        path: 'staff/permissions',
        name: 'StaffPermissions',
        component: StaffPermissions,
        meta: { 
          title: '鍛樺伐鏉冮檺绠＄悊',
          requiredRoles: [2, 4] 
        }
      },
      {
        path: 'staff/templates',
        name: 'StaffTemplates',
        component: StaffTemplates,
        meta: { 
          title: '鏉冮檺妯℃澘绠＄悊',
          requiredRoles: [2, 4] 
        }
      },
      {
        path: 'system/staff',
        redirect: '/staff/accounts'
      },
      {
        path: 'system/params',
        name: 'ParamConfig',
        component: ParamConfig,
        meta: {
          title: '参数配置',
          requiredRoles: [4]
        }
      },
      {
        path: 'system/dicts',
        name: 'DictManagement',
        component: DictManagement,
        meta: {
          title: '字典管理',
          requiredRoles: [4]
        }
      },
      {
        path: 'system/config',
        name: 'SystemConfig',
        component: SystemConfig,
        meta: { 
          title: '绯荤粺閰嶇疆',
          requiredRoles: [4] 
        }
      },

      // 机构管理
      {
        path: 'organizations',
        name: 'OrganizationsList',
        component: OrganizationsList,
        meta: {
          title: '机构管理',
          requiredRoles: [4]
        }
      },

      // 闂ㄥ簵绠＄悊
      {
        path: 'stores',
        name: 'StoresList',
        component: StoresList,
        meta: { 
          title: '闂ㄥ簵绠＄悊',
          requiredRoles: [2, 4] 
        }
      },

      // 浼樻儬鍒哥鐞?
      {
        path: 'coupons',
        name: 'CouponsList',
        component: CouponsList,
        meta: { 
          title: '优惠券管理',
          requiredRoles: [4] 
        }
      },

      // 传播链
      {
        path: 'propagation',
        name: 'PropagationIndex',
        component: PropagationIndex,
        meta: {
          title: '传播链',
          requiredRoles: [4]
        }
      },

      // 鍕嬬珷绯荤粺
      {
        path: 'medals',
        name: 'MedalsList',
        component: MedalsList,
        meta: { 
          title: '鍕嬬珷绯荤粺',
          requiredRoles: [4] 
        }
      },

      // 璇勪环绠＄悊
      {
        path: 'reviews',
        name: 'ReviewsList',
        component: ReviewsList,
        meta: { 
          title: '璇勪环绠＄悊',
          requiredRoles: [4]
        }
      },

      // 搴撳瓨绠＄悊
      {
        path: 'stock',
        name: 'StockList',
        component: StockList,
        meta: { 
          title: '库存管理',
          requiredRoles: [2, 4] 
        }
      },
      {
        path: 'stock/logs',
        name: 'StockLogs',
        component: StockLogs,
        meta: {
          title: '库存流水',
          requiredRoles: [2, 4]
        }
      },
      {
        path: 'stock/warnings',
        name: 'StockWarnings',
        component: StockWarnings,
        meta: {
          title: '库存预警',
          requiredRoles: [2, 4]
        }
      },

      // 鏍搁攢绠＄悊
      {
        path: 'verification',
        name: 'VerificationList',
        component: VerificationList,
        meta: { 
          title: '鏍搁攢绠＄悊',
          requiredRoles: [2, 4] 
        }
      },

      // 浜烘墠搴撶鐞?
      {
        path: 'talent',
        name: 'TalentList',
        component: TalentList,
        meta: { 
          title: '人才库管理',
          requiredRoles: [2, 4] 
        }
      },

      // 鍏煎鏃ц矾鐢?
      {
        path: 'stats',
        name: 'Stats',
        component: Stats,
        meta: { 
          title: '鏁版嵁缁熻',
          requiredRoles: [3, 4] 
        }
      },
      {
        path: 'goods/list',
        name: 'GoodsList',
        component: GoodsList,
        meta: { 
          title: '鍟嗗搧绠＄悊',
          requiredRoles: [3, 4] 
        }
      },
      {
        path: 'order/list',
        redirect: '/orders'
      },
      {
        path: 'material/list',
        redirect: '/materials'
      },
      {
        path: 'article/list',
        redirect: '/materials'
      },
      {
        path: 'articles',
        redirect: '/materials'
      },
      {
        path: 'articles/edit',
        redirect: '/materials'
      },
      {
        path: 'articles/preview',
        redirect: '/materials'
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

/**
 * 璺敱瀹堝崼 - 鏉冮檺鎺у埗
 * 1. 妫€鏌ユ槸鍚︾櫥褰曪紙token锛?
 * 2. 妫€鏌ヨ鑹叉潈闄愶紙requiredRoles锛?
 */
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token')
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null')
  const userRole = userInfo?.role

  // 涓嶉渶瑕佽璇佺殑椤甸潰鐩存帴鏀捐
  if (to.meta.requiresAuth === false) {
    next()
    return
  }

  // 鏈櫥褰曪紝璺宠浆鍒扮櫥褰曢〉
  if (!token) {
    next('/login')
    return
  }

  if (to.meta.platformOnly && userRole !== 4) {
    next('/403')
    return
  }

  // role=2 鍚堜綔鍟嗙鐞嗗憳 鎴?role=3 鍛樺伐锛氭寜椤甸潰鏉冮檺鎺у埗锛屼笉璧?requiredRoles
  if (userRole === 2 || userRole === 3) {
    let userPermissions = JSON.parse(localStorage.getItem('userPermissions') || 'null')

    // 鏉冮檺鏈姞杞芥椂锛屽厛浠庡悗绔幏鍙栧啀鏀捐锛堣В鍐崇櫥褰曞悗寮傛鍔犺浇鏃跺簭闂锛?
    if (!userPermissions) {
      try {
        const { getStaffPermissions } = await import('@/api/permissions')
        const perms = await getStaffPermissions(userInfo.userId)
        localStorage.setItem('userPermissions', JSON.stringify(perms))
        userPermissions = perms
      } catch (e) {
        console.error('璺敱瀹堝崼鑾峰彇鏉冮檺澶辫触:', e)
        next('/403')
        return
      }
    }

    const pages = userPermissions?.pages || []

    // 璺敱涓庢潈闄怚D鐨勬槧灏?
    const routePermissionMap = {
      '/dashboard': 'dashboard:view',
      '/users': 'user:view',
      '/private-domains': 'private-domain:view',
      '/channels': 'channel:view',
      '/promotions/audit': 'promotion:audit',
      '/goods-mall': 'goods_mall:view',
      '/orders': 'order:view',
      '/finance/split': 'finance:split',
      '/finance/model': 'finance:model',
      '/finance/points': 'finance:points',
      '/devices': 'device:view',
      '/device-ownership-applications': 'device:ownership:review',
      '/skin-reports': 'skin:report:view',
      '/materials': 'material:view',
      '/banners': 'banner:view',
      '/knowledge': 'knowledge:view',
      '/stock': 'stock:view',
      '/stock/logs': 'stock:view',
      '/stock/warnings': 'stock:view',
      '/messages': 'message:view',
      '/stores': 'store:view',
      '/verification': 'verification:view',
      '/coupons': 'coupon:view',
      '/propagation': 'propagation:view',
      '/medals': 'medal:view',
      '/reviews': 'review:view',
      '/staff/management': 'staff:management',
      '/staff/permissions': 'staff:permissions',
      '/staff/templates': 'staff:templates',
      '/system/params': 'system:param:view',
      '/system/dicts': 'dict:view',
      '/system/config': 'system:config',
      '/organizations': 'organization:view'
    }

    const permissionId = routePermissionMap[to.path]
    if (permissionId) {
      // 闇€瑕佹鏌ユ潈闄愮殑璺敱
      if (!pages.includes(permissionId)) {
        // 娌℃湁鏉冮檺锛岃烦杞埌绗竴涓湁鏉冮檺鐨勯〉闈?
        const firstAllowed = Object.entries(routePermissionMap).find(([, pid]) => pages.includes(pid))
        next(firstAllowed ? firstAllowed[0] : '/403')
        return
      }
    }
    // 娌℃湁鍦ㄦ槧灏勮〃涓殑璺敱锛堝閲嶅畾鍚戣矾鐢憋級鐩存帴鏀捐
    next()
    return
  }

  // 闈炲憳宸ヨ鑹诧細鎸?requiredRoles 鎺у埗
  const requiredRoles = to.meta.requiredRoles
  if (requiredRoles && requiredRoles.length > 0) {
    if (!userRole || !requiredRoles.includes(userRole)) {
      next('/403')
      return
    }
  }

  // 閫氳繃鎵€鏈夋鏌ワ紝鏀捐
  next()
})

export default router
